import { createContext } from "react"

type ContentfulLpContextType = {
  isAnnualDiscountApplied: boolean
  isSalesPage: boolean
  setIsAnnualDiscountApplied?: (v: boolean) => void
}

const ContentfulLpContext = createContext<ContentfulLpContextType>({
  isAnnualDiscountApplied: true,
  isSalesPage: false,
})

export default ContentfulLpContext
